import { FC } from "react";
import React from "react";
import Alert from '@mui/material/Alert';
import { WellKnownNotices } from "./NotificationEntities";
import "./Notifications.scss";
import { useAppState } from "../../../../Redux/ReduxHooks";
import { Dispatch } from "../../../Dispatch";
import { MyStorage } from "../../../../Storage";
import { BookingDataOwnership } from "../../../../Services/BookingEntities";

/** Generic component that implements material UI Alert component in order to display notifications to the user about various events during the booking flow of a Phone to CNP booking. Consumes data from PhoneToCnp redux store slice to decide what to display in the alert message. */
export const Notice: FC = () => {

    const activeNoticeType = useAppState(state => state.PhoneToCnp.NoticeToDisplay);
    const booking = useAppState(state => state.PhoneToCnp.Booking)!;

    if (!activeNoticeType) return null;
    if (booking.DataOwnership !== BookingDataOwnership.WritableLink) return null; // Only display notices for bookings that are owned by the user. Shared bookings (read-only) don't display notices.

    const noticeProps = WellKnownNotices[activeNoticeType];
    const primaryText = typeof noticeProps.PrimaryText === "function" ? noticeProps.PrimaryText(booking.DispatchBookingId!) : noticeProps.PrimaryText;

    function CloseNotice() {
        Dispatch.PhoneToCnp.HideNotice();
        RecordNoticeDisplayed();
    }

    /** Records the fact that this notice has been displayed for this booking in the persistent (local) storage, so it won't be displayed again.  */
    function RecordNoticeDisplayed() {
        const displayedNotices = MyStorage.BookingNotifications.LoadData() ?? {};
        const displayedNoticesForTheBooking = displayedNotices[booking.BookingId];

        // initialize the array for this booking if it doesn't exist yet.
        if (!displayedNoticesForTheBooking) displayedNotices[booking.BookingId] = [];

        // store the fact that this notice has been displayed for this booking, so it won't be displayed again.
        if (!displayedNotices[booking.BookingId].includes(activeNoticeType!)) {
            displayedNotices[booking.BookingId].push(activeNoticeType!);
            MyStorage.BookingNotifications.StoreData(displayedNotices);
        }
    }

    return (
        <Alert icon={false} severity="warning" onClose={CloseNotice} className="notice-alert">
            <span className="primary-text" dangerouslySetInnerHTML={{ __html: primaryText }}></span> <span className="secondary-text" dangerouslySetInnerHTML={{ __html: noticeProps.SecondaryText }}></span>
        </Alert>
    );
}
